<template>
  <main
    class="
      flex flex-col
      items-center
      mt-4
      mx-auto
      px-5
      max-w-screen-lg
      lg:-mt-14
    "
  >
    <section class="text-center">
      <div class="relative">
        <img
          alt="A bird full of hope"
          class="w-full lg:hidden"
          src="@/assets/img/bluebird/1-2.png"
          style="max-width: 486px; max-height: 486px"
        />
        <img
          alt="A bird full of hope"
          class="hidden lg:block lg:mt-16 lg:mx-auto"
          src="@/assets/img/bluebird/1.png"
          style="max-height: 425px; max-width: 640px"
        />
        <h2
          class="
            -mt-8
            text-large-title
            font-bold
            lg:mt-0 lg:text-very-large-title
          "
        >
          Fashion Make Up Game
        </h2>
      </div>
      <p class="mt-4 text-ice-10 text-callout lg:mt-2 lg:text-title-3">
        The unique fashion games where you act like a makeover artist or a fashion designer who is busy making the fashion model look more attractive and fashionable.
      </p>
    </section>
    <section class="index_section2__Vp-Dd">
      <ol class="flex flex-col space-y-32">
        <li>
          <img
            style="max-height: 320px; max-width: 360px"
            src="@/assets/img/bluebird/3.png"
          />
          <div>
            <h3>Turn into a fashionable beauty expert.</h3>
            <p>Make up with your style and pick your favorite match. Enjoy the fun of role makeover.</p>
          </div>
        </li>
        <li>
          <img
            style="max-height: 320px; max-width: 360px"
            src="@/assets/img/bluebird/4.png"
          />
          <div>
            <h3>Tons of collocation for you to choose.</h3>
            <p>A variety of cosmetics for you to choose from, such as: lipsticks, eyeliner, Powder, mascara, and eye-shadow.</p>
          </div>
        </li>
        <li>
          <img
            style="max-height: 320px; max-width: 360px"
            src="@/assets/img/bluebird/5.png"
          />
          <div>
            <h3>Experience the real makeup process.</h3>
            <p>Choose your favorite model and give her a stunning makeup!</p>
          </div>
        </li>
      </ol>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
